// import React from 'react'
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';
// import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';


// function Slider() {
//     return (
//         <div className="w-full px-4">
//             <Swiper
//                 className="h-[300px]"
//                 modules={[Navigation, Pagination, Scrollbar, A11y]}
//                 spaceBetween={2}
//                 navigation
//                 pagination={{ clickable: true }}
//                 scrollbar={{ draggable: true }}
//                 breakpoints={{
//                     // 300: {
//                     //     slidesPerView: 1,
//                     // },
//                     // 480: {
//                     //     slidesPerView: 2,
//                     // },
//                     // 640: {
//                     //     slidesPerView: 3,
//                     // },
//                     768: {
//                         slidesPerView: 4,
//                     },
//                     1024: {
//                         slidesPerView: 5,
//                     },
//                     1280: {
//                         slidesPerView: 6,
//                     },
//                 }}
//             >
//                 <SwiperSlide>
//                     <a href="https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/REVISTA%20C%C3%81MARA%20AQP_%20MARZO%202025_compressed.pdf" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center" >
//                         <img src="/revista43.jpeg" alt="" className="w-32 h-auto" />
//                         <h2 className="slider-text">Revista 43</h2>
//                     </a>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <a href="https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/CCIA-revista%20DICIEMBRE-2024-web%201p_compressed.pdf" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center" >
//                         <img src="/revista43.jpeg" alt="" className="w-32 h-auto" />
//                         <h2 className="slider-text">Revista 42</h2>
//                     </a>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <a href="https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/CCIA-revista%20septiembre-2024-simples.pdf" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center" >
//                         <img src="/revista41.jpg" alt="" className="w-32 h-auto" />
//                         <h2 className="slider-text">Revista 41</h2>
//                     </a>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <a href="https://www.camara-arequipa.org.pe/public/archivos/revistas/CCIA-revista%20mayo-2024-web.pdf" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center" >
//                         <img src="/revista_40anios.jpg" alt="" className="w-32 h-auto" />
//                         <h2 className="slider-text">Revista 40</h2>
//                     </a>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <a href="https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/Revista-CCIA-marzo-2024.pdf" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center" >
//                         <img src="/revista39.jpg" alt="" className="w-32 h-auto" />
//                         <h2 className="slider-text">Revista 39</h2>
//                     </a>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <a href="https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/CCIA-2023-diciembre.pdf" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center" >
//                         <img src="/revista38.jpg" alt="" className="w-32 h-auto" />
//                         <h2 className="slider-text">Revista 38</h2>
//                     </a>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <a href="https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/revista_setiembre_2023.pdf" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center" >
//                         <img src="/revista37.jpg" alt="" className="w-32 h-auto" />
//                         <h2 className="slider-text">Revista 37</h2>
//                     </a>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <a href="https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/Revista_CCIA_julio_2023.pdf" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center" >
//                         <img src="/revista36.jpg" alt="" className="w-32 h-auto" />
//                         <h2 className="slider-text">Revista 36</h2>
//                     </a>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <a href="https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/Revista_CCIA_julio_2023.pdf" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center" >
//                         <img src="/revista1.jpg" alt="" className="w-32 h-auto" />
//                         <h2 className="slider-text">Revista 1</h2>
//                     </a>
//                 </SwiperSlide>


//                 {/* ... */}
//             </Swiper>
//         </div>
//     )
// }

// export default Slider

// import React from 'react'
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
// import 'swiper/swiper-bundle.css';

// function Slider() {
//     return (
//         <div className="w-full flex justify-start py-6 bg-white">
//             <div className="w-full max-w-7xl mx-auto px">

//                 <Swiper
//                     modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
//                     spaceBetween={20}
//                     slidesPerView={revistas.length < 6 ? revistas.length : 6}
//                     centeredSlides={true}
//                     navigation
//                     pagination={{ clickable: true }}
//                     scrollbar={{ draggable: true }}
//                     autoplay={{ delay: 3000, disableOnInteraction: false }}
//                     loop={true}
//                     touchRatio={5}
//                     grabCursor={true}
//                     breakpoints={{
//                         480: { slidesPerView: 2 },
//                         640: { slidesPerView: 3 },
//                         768: { slidesPerView: 4 },
//                         1024: { slidesPerView: 5 },
//                         1280: { slidesPerView: 6 },
//                       }}
//                     className="!overflow-visible"
//                 >
//                     {[
//                         { src: "/revista43.jpeg", title: "Revista 43", link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/REVISTA%20C%C3%81MARA%20AQP_%20MARZO%202025_compressed.pdf" },
//                         { src: "/revista42.jpeg", title: "Revista 42", link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/CCIA-revista%20DICIEMBRE-2024-web%201p_compressed.pdf" },
//                         { src: "/revista41.jpg", title: "Revista 41", link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/CCIA-revista%20septiembre-2024-simples.pdf" },
//                         { src: "/revista_40anios.jpg", title: "Revista 40", link: "https://www.camara-arequipa.org.pe/public/archivos/revistas/CCIA-revista%20mayo-2024-web.pdf" },
//                         { src: "/revista39.jpg", title: "Revista 39", link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/Revista-CCIA-marzo-2024.pdf" },
//                         { src: "/revista38.jpg", title: "Revista 38", link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/CCIA-2023-diciembre.pdf" },
//                         { src: "/revista37.jpg", title: "Revista 37", link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/revista_setiembre_2023.pdf" },
//                         { src: "/revista36.jpg", title: "Revista 36", link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/Revista_CCIA_julio_2023.pdf" },
//                         { src: "/revista1.jpg", title: "Revista 1", link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/Revista_CCIA_julio_2023.pdf" },
//                     ].map((revista, i) => (
//                         <SwiperSlide key={i} className="flex justify-center ml-20">
//                             <a
//                                 href={revista.link}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="flex flex-col items-center"
//                             >
//                                 <img
//                                     src={revista.src}
//                                     alt={revista.title}
//                                     className="w-full max-w-[130px] h-auto object-contain"
//                                 />
//                                 <h2 className="text-center text-sm mt-2">{revista.title}</h2>
//                             </a>
//                         </SwiperSlide>

//                     ))}
//                 </Swiper>
//             </div>
//         </div>
//     )
// }

// export default Slider

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

function Slider() {
    const revistas = [
        {
            src: "/revista43.jpeg",
            title: "Revista 43",
            link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/REVISTA%20C%C3%81MARA%20AQP_%20MARZO%202025_compressed.pdf"
        },
        {
            src: "/revista42.jpeg",
            title: "Revista 42",
            link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/CCIA-revista%20DICIEMBRE-2024-web%201p_compressed.pdf"
        },
        {
            src: "/revista41.jpg",
            title: "Revista 41",
            link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/CCIA-revista%20septiembre-2024-simples.pdf"
        },
        {
            src: "/revista_40anios.jpg",
            title: "Revista 40",
            link: "https://www.camara-arequipa.org.pe/public/archivos/revistas/CCIA-revista%20mayo-2024-web.pdf"
        },
        {
            src: "/revista39.jpg",
            title: "Revista 39",
            link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/Revista-CCIA-marzo-2024.pdf"
        },
        {
            src: "/revista38.jpg",
            title: "Revista 38",
            link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/CCIA-2023-diciembre.pdf"
        },
        {
            src: "/revista37.jpg",
            title: "Revista 37",
            link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/revista_setiembre_2023.pdf"
        },
        {
            src: "/revista36.jpg",
            title: "Revista 36",
            link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/Revista_CCIA_julio_2023.pdf"
        },
        {
            src: "/revista1.jpg",
            title: "Revista 1",
            link: "https://www.camara-arequipa.org.pe/erpccia/public/archivos/revistas/Revista_CCIA_julio_2023.pdf"
        },
    ];

    return (
        <div className="w-full py-6 bg-white">
            <div className="max-w-7xl mx-auto px-4">
                <Swiper
                    modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                    spaceBetween={16}
                    slidesPerView={8}
                    loop={true}
                    loopedSlides={revistas.length}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    grabCursor={true}
                    speed={800}
                    className="!overflow-visible"
                >
                    {revistas.map((revista, i) => (
                        <SwiperSlide key={i}>
                            <a
                                href={revista.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex flex-col items-center"
                            >
                                <img
                                    src={revista.src}
                                    alt={revista.title}
                                    className="w-full max-w-[130px] h-auto object-contain"
                                />
                                <h2 className="slider-text_revistas"> {revista.title}</h2>
                            </a>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default Slider;
